import "./../scss/main.scss";
import "lazysizes";
import "./nav";
import "./modal";
import "./swiper";